module.exports = __webpack_public_path__ + "img/cross2yellow.347211d9.png";